import { Pagination } from "@ir/ui";
import { PageFooter } from "@src/presentation/components/Layout/common";

interface OrganizationsFooterProps {
  totalOrganizations: number;
  itemsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  loading: boolean;
}

export const OrganizationsFooter = ({
  totalOrganizations,
  itemsPerPage,
  currentPage,
  onPageChange,
  loading,
}: OrganizationsFooterProps) => {
  if (totalOrganizations <= itemsPerPage) {
    return null;
  }

  return (
    <PageFooter>
      <Pagination
        totalItems={totalOrganizations}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={onPageChange}
        isDisabled={loading}
        aria-label="Organizations Pagination"
      />
    </PageFooter>
  );
};
